export default "__VITE_ASSET__BlYBqa2P__"